// @ts-nocheck
import { to_array } from "./to_array"

/**
 * Applies function with iterable arguments.
 *
 * Converts args to array and applies to function. Similar to Function.prototype.apply.
 *
 * @param f - Function to apply
 * @param args - Arguments as iterable or primitive
 * @returns Result of function application
 *
 * @example
 * ```ts
 * import { apply } from "@pdfking/rfunc"
 *
 * apply((a, b) => a + b, [1, 2]) // 3
 * ```
 */
export const apply = (f, args) => f.apply(null, to_array(args))
